import PatientAlertForm from './PatientAlertForm'

export default PatientAlertForm
